import { TenderDocumentsStateTypes, TenderDocumentsActionTypes } from "./TenderDocuments.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: TenderDocumentsStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const TenderDocumentsReducer = (
  state: TenderDocumentsStateTypes = INITIAL_STATE,
  action: any
): TenderDocumentsStateTypes => {
  switch (action.type) {
    case TenderDocumentsActionTypes.FETCH_ALL_TENDER_DOCUMENTS:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case TenderDocumentsActionTypes.FETCH_ALL_TENDER_DOCUMENTS_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case TenderDocumentsActionTypes.FETCH_ALL_TENDER_DOCUMENTS_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case TenderDocumentsActionTypes.FETCH_ALL_TENDER_DOCUMENTS_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case TenderDocumentsActionTypes.FETCH_ONE_TENDER_DOCUMENTS:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case TenderDocumentsActionTypes.FETCH_ONE_TENDER_DOCUMENTS_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case TenderDocumentsActionTypes.FETCH_ONE_TENDER_DOCUMENTS_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case TenderDocumentsActionTypes.FETCH_ONE_TENDER_DOCUMENTS_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default TenderDocumentsReducer;
